import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./CategoryAndAttibutes.module.sass";
import Card from "../../../../components/Card";
import Dropdown from "../../../../components/Dropdown";
import Tooltip from "../../../../components/Tooltip";
import Checkbox from "../../../../components/Checkbox";
import { WithContext as ReactTags } from "react-tag-input";

const hardSkills = [
  {
    id: 0,
    title: "Informatique / Bureautique",
  },
  {
    id: 1,
    title: "Langues étrangères",
  },
  {
    id: 2,
    title: "Techniques de vente",
  },
  {
    id: 3,
    title: "Service client",
  },
  {
    id: 4,
    title: "Gestion administrative",
  },
  {
    id: 5,
    title: "Comptabilité / Finance",
  },
  {
    id: 6,
    title: "Marketing / Communication",
  },
  {
    id: 7,
    title: "Logistique / Supply Chain",
  },
  {
    id: 8,
    title: "Qualité / Contrôle",
  },
  {
    id: 9,
    title: "Maintenance / Technique",
  },
  {
    id: 10,
    title: "Production / Fabrication",
  },
  {
    id: 11,
    title: "Ressources Humaines",
  },
  {
    id: 12,
    title: "Juridique / Réglementaire",
  },
  {
    id: 13,
    title: "Sécurité / Hygiène",
  },
  {
    id: 14,
    title: "Conduite / Permis",
  },
];

const softSkills = [
  {
    id: 0,
    title: "Communication",
  },
  {
    id: 1,
    title: "Travail en équipe",
  },
  {
    id: 2,
    title: "Autonomie",
  },
  {
    id: 3,
    title: "Adaptabilité",
  },
  {
    id: 4,
    title: "Créativité",
  },
  {
    id: 5,
    title: "Esprit d'initiative",
  },
  {
    id: 6,
    title: "Rigueur",
  },
  {
    id: 7,
    title: "Curiosité",
  },
  {
    id: 8,
    title: "Gestion du stress",
  },
  {
    id: 9,
    title: "Leadership",
  },
  {
    id: 10,
    title: "Empathie",
  },
  {
    id: 11,
    title: "Persévérance",
  },
  {
    id: 12,
    title: "Esprit critique",
  },
  {
    id: 13,
    title: "Organisation",
  },
  {
    id: 14,
    title: "Ponctualité",
  },
];

const optionsNiveauEtudes = [
  "Sélectionner le niveau",
  "Bac",
  "Bac+1",
  "Bac+2",
  "Bac+3",
  "Bac+4",
  "Bac+5 et plus"
];

const optionsExperience = [
  "Sélectionner l'expérience",
  "Aucune expérience",
  "Moins de 6 mois",
  "6 mois à 1 an",
  "1 à 2 ans",
  "Plus de 2 ans"
];

const KeyCodes = {
  comma: 188,
  enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

const CategoryAndAttibutes = ({ className, offer, onOfferChange, onDropdownChange, onCompetencesChange }) => {
  const [niveauEtudes, setNiveauEtudes] = useState(offer?.educational_level_required || optionsNiveauEtudes[0]);
  const [experienceRequise, setExperienceRequise] = useState(offer?.required_experience || optionsExperience[0]);

  const [selectedHardSkills, setSelectedHardSkills] = useState([]);
  const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);
  const [competencesSupplementaires, setCompetencesSupplementaires] = useState([]);

  // Fonction pour parser les compétences depuis l'offre
  const parseCompetencesFromOffer = (competencesString) => {
    if (!competencesString) return { hardSkills: [], softSkills: [], supplementaires: [] };
    
    try {
      const competences = JSON.parse(competencesString);
      console.log("Compétences parsées:", competences);
      
      const hardSkills = [];
      const softSkills = [];
      const supplementaires = [];
      
      competences.forEach(comp => {
        console.log("Traitement compétence:", comp);
        if (comp.id.startsWith('hard_')) {
          const hardSkillId = parseInt(comp.id.replace('hard_', ''));
          console.log("Hard skill ID extrait:", hardSkillId);
          hardSkills.push(hardSkillId);
        } else if (comp.id.startsWith('soft_')) {
          const softSkillId = parseInt(comp.id.replace('soft_', ''));
          console.log("Soft skill ID extrait:", softSkillId);
          softSkills.push(softSkillId);
        } else {
          supplementaires.push(comp);
        }
      });
      
      return { hardSkills, softSkills, supplementaires };
    } catch (error) {
      console.error("Erreur lors du parsing des compétences:", error);
      return { hardSkills: [], softSkills: [], supplementaires: [] };
    }
  };

  // Initialiser les compétences à partir de l'offre
  useEffect(() => {
    if (offer?.competences) {
      console.log("CategoryAndAttibutes - Initialisation des compétences depuis l'offre:", offer.competences);
      const { hardSkills, softSkills, supplementaires } = parseCompetencesFromOffer(offer.competences);
      console.log("Hard skills à cocher:", hardSkills);
      console.log("Soft skills à cocher:", softSkills);
      console.log("Compétences supplémentaires:", supplementaires);
      
      setSelectedHardSkills(hardSkills);
      setSelectedSoftSkills(softSkills);
      setCompetencesSupplementaires(supplementaires);
    }
  }, [offer?.competences]);

  // Fonction pour créer les tags à partir des compétences sélectionnées
  const getAllSelectedSkills = () => {
    const hardSkillTags = selectedHardSkills.map(id => {
      const skill = hardSkills.find(s => s.id === id);
      return { id: `hard_${id}`, text: skill?.title || '' };
    });

    const softSkillTags = selectedSoftSkills.map(id => {
      const skill = softSkills.find(s => s.id === id);
      return { id: `soft_${id}`, text: skill?.title || '' };
    });

    return [...hardSkillTags, ...softSkillTags, ...competencesSupplementaires];
  };

  // Fonction pour transmettre les compétences au parent
  const updateCompetencesInParent = () => {
    if (onCompetencesChange) {
      const allSkills = getAllSelectedSkills();
      onCompetencesChange(allSkills);
    }
  };

  // Fonction pour gérer les changements de dropdowns
  const handleNiveauEtudesChange = (value) => {
    setNiveauEtudes(value);
    if (onDropdownChange) {
      onDropdownChange('educational_level_required', value);
    }
  };

  const handleExperienceChange = (value) => {
    setExperienceRequise(value);
    if (onDropdownChange) {
      onDropdownChange('required_experience', value);
    }
  };

  const handleHardSkillChange = (id) => {
    let newSelectedHardSkills;
    if (selectedHardSkills.includes(id)) {
      // Toujours permettre de décocher
      newSelectedHardSkills = selectedHardSkills.filter((x) => x !== id);
    } else {
      // Vérifier la limite STRICTE de 10 compétences AVANT d'ajouter
      const currentTotal = selectedHardSkills.length + selectedSoftSkills.length + competencesSupplementaires.length;
      if (currentTotal < 10) {
        newSelectedHardSkills = [...selectedHardSkills, id];
      } else {
        return; // Ne pas ajouter si limite atteinte
      }
    }
    setSelectedHardSkills(newSelectedHardSkills);
    // Mettre à jour les compétences dans le parent après le changement d'état
    setTimeout(updateCompetencesInParent, 0);
  };

  const handleSoftSkillChange = (id) => {
    let newSelectedSoftSkills;
    if (selectedSoftSkills.includes(id)) {
      // Toujours permettre de décocher
      newSelectedSoftSkills = selectedSoftSkills.filter((x) => x !== id);
    } else {
      // Vérifier la limite STRICTE de 10 compétences AVANT d'ajouter
      const currentTotal = selectedHardSkills.length + selectedSoftSkills.length + competencesSupplementaires.length;
      if (currentTotal < 10) {
        newSelectedSoftSkills = [...selectedSoftSkills, id];
      } else {
        return; // Ne pas ajouter si limite atteinte
      }
    }
    setSelectedSoftSkills(newSelectedSoftSkills);
    // Mettre à jour les compétences dans le parent après le changement d'état
    setTimeout(updateCompetencesInParent, 0);
  };

  const handleDelete = (i) => {
    const allTags = getAllSelectedSkills();
    const tagToDelete = allTags[i];
    
    // Si c'est un hard skill, le retirer de selectedHardSkills
    if (tagToDelete.id.startsWith('hard_')) {
      const hardSkillId = parseInt(tagToDelete.id.replace('hard_', ''));
      setSelectedHardSkills(selectedHardSkills.filter(id => id !== hardSkillId));
    }
    // Si c'est un soft skill, le retirer de selectedSoftSkills
    else if (tagToDelete.id.startsWith('soft_')) {
      const softSkillId = parseInt(tagToDelete.id.replace('soft_', ''));
      setSelectedSoftSkills(selectedSoftSkills.filter(id => id !== softSkillId));
    }
    // Sinon c'est une compétence supplémentaire
    else {
      setCompetencesSupplementaires(competencesSupplementaires.filter((tag, index) => index !== (i - selectedHardSkills.length - selectedSoftSkills.length)));
    }
  };

  const handleAddition = (tag) => {
    // Vérifier la limite de 10 compétences avant d'ajouter
    const currentTotal = selectedHardSkills.length + selectedSoftSkills.length + competencesSupplementaires.length;
    if (currentTotal < 10) {
      const newCompetencesSupplementaires = [...competencesSupplementaires, tag];
      setCompetencesSupplementaires(newCompetencesSupplementaires);
      // Mettre à jour les compétences dans le parent après le changement d'état
      setTimeout(updateCompetencesInParent, 0);
    }
  };

  const handleDrag = (tag, currPos, newPos) => {
    // Pour simplifier, on ne permet le drag que pour les compétences supplémentaires
    const allTags = getAllSelectedSkills();
    const newTags = [...allTags].slice();
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    // Note: Cette fonctionnalité est complexe avec les différents types, on la garde simple
  };

  const handleTagClick = (index) => {
    console.log("The tag at index " + index + " was clicked");
  };

  const onClearAll = () => {
    setSelectedHardSkills([]);
    setSelectedSoftSkills([]);
    setCompetencesSupplementaires([]);
  };

  const onTagUpdate = (i, newTag) => {
    // Pour simplifier, on ne permet l'édition que pour les compétences supplémentaires
    const hardSkillsCount = selectedHardSkills.length;
    const softSkillsCount = selectedSoftSkills.length;
    const supplementaryIndex = i - hardSkillsCount - softSkillsCount;
    
    if (supplementaryIndex >= 0) {
      const updatedTags = competencesSupplementaires.slice();
      updatedTags.splice(supplementaryIndex, 1, newTag);
      setCompetencesSupplementaires(updatedTags);
    }
  };

  return (
    <Card
      className={cn(styles.card, className)}
      title="Profil recherché"
      classTitle="title-purple"
    >
      <div className={styles.images}>
        <div className={styles.group}>
          <Dropdown
            className={styles.field}
            label="Niveau d'études requis"
            value={niveauEtudes}
            setValue={handleNiveauEtudesChange}
            options={optionsNiveauEtudes}
          />
          <Dropdown
            className={styles.field}
            label="Expérience requise"
            value={experienceRequise}
            setValue={handleExperienceChange}
            options={optionsExperience}
          />
        </div>

        <div className={styles.divider}></div>

        <div className={styles.head}>
          <div className={styles.label}>
            Compétences supplémentaires{" "}
            <Tooltip
              className={styles.tooltip}
              title="Ajoutez d'autres compétences spécifiques au poste"
              icon="info"
              place="right"
            />
          </div>
          <div className={styles.counter}>
            <span>{getAllSelectedSkills().length}</span>/10 compétences
          </div>
        </div>
        <div className={styles.tags}>
          <ReactTags
            handleDelete={handleDelete}
            handleAddition={handleAddition}
            handleDrag={handleDrag}
            delimiters={delimiters}
            handleTagClick={handleTagClick}
            onClearAll={onClearAll}
            onTagUpdate={onTagUpdate}
            minQueryLength={2}
            maxLength={30}
            autofocus={false}
            allowDeleteFromEmptyInput={false}
            autocomplete={false}
            readOnly={true}
            allowUnique={false}
            allowDragDrop={true}
            inline={true}
            inputFieldPosition="inline"
            allowAdditionFromPaste={false}
            editable={false}
            clearAll={false}
            tags={getAllSelectedSkills()}
          />
        </div>
      </div>
    </Card>
  );
};

export default CategoryAndAttibutes;
